export default  {
  bindings: {
    source: '<',
    formTab: '='
  },
  controller: 'upgradeFormController',
  template: require('../views/upgrade.form.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/upgrade/components/upgrade.form.component.js